import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  UPDATE_APPOINTMENT_END_TIME_SUCCESS,
  UPDATE_APPOINTMENT_END_TIME_FAILURE,
  UPDATE_APPOINTMENT_END_TIME_RESET,
  UPDATE_APPOINTMENT_END_TIME_LOADING,
} = therapyPlanningAction;

const initialState: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const updateAppointmentEndTimeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_APPOINTMENT_END_TIME_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: true,
      };

    case UPDATE_APPOINTMENT_END_TIME_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case UPDATE_APPOINTMENT_END_TIME_LOADING:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_APPOINTMENT_END_TIME_RESET:
      return initialState;

    default:
      return state;
  }
};
